import {
    commitMutation,
    graphql
} from 'react-relay'
import environment from '../../Environment'


const mutation = graphql`
    mutation CreateCustomerOriginMutation($data: CustomerOriginCreateInput!) {
        createCustomerOrigin(data:$data) {
            id
      }
    }
  `

export default (data, callback) => {
    const variables = {
        data
    }

    commitMutation(
        environment,
        {
            mutation,
            variables,
            onCompleted: (response) => {
                callback({ status: 'OK', pyload: response.createCustomerOrigin })
            },
            onError: err => callback({ status: 'KO', message: err })
        },
    )
}